import React from "react";
import { useTranslation } from "react-i18next";
import { messages } from "../../../locales/messages";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import type { ComputerWithHealthResponseDto } from "../../../../typescript-fetch-sdk/api";
import { normalizeStatus, formatDateTime, formatTimeElapsed } from "./utils";
import {
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalCloseButton,
  StatusBadge,
  StatusDot,
} from "./styled";

export const ComputerDetailModal: React.FC<{
  computer: ComputerWithHealthResponseDto | null;
  open: boolean;
  onClose: () => void;
}> = ({ computer, open, onClose }) => {
  const { t } = useTranslation();

  if (!computer) return null;

  return (
    <Modal open={open} onClose={onClose}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle>{`${computer?.computerName} - ${t(
            messages.Health_Details()
          )}`}</ModalTitle>
          <ModalCloseButton onClick={onClose}>
            <Close />
          </ModalCloseButton>
        </ModalHeader>

        <div style={{ marginBottom: "20px" }}>
          {" "}
          <p>
            <strong>{t(messages.Status())}:</strong>{" "}
            <StatusBadge status={normalizeStatus(computer?.status)}>
              <StatusDot status={normalizeStatus(computer?.status)} />
              {computer?.status}
            </StatusBadge>
          </p>
          <p>
            <strong>{t(messages.Last_Check())}:</strong>{" "}
            {computer?.lastCheckDateTime
              ? formatDateTime(computer?.lastCheckDateTime)
              : t(messages.Never())}
          </p>
          <p>
            <strong>{t(messages.Time_Elapsed())}:</strong>{" "}
            {computer?.minutesSinceLastCheck
              ? formatTimeElapsed(computer?.minutesSinceLastCheck)
              : t(messages.few_seconds_ago())}
          </p>
          <p>
            <strong>{t(messages.Currently_Healthy())}:</strong>{" "}
            {computer?.isCurrentlyHealthy
              ? t(messages.Yes())
              : t(messages.No())}
          </p>
          <p>
            <strong>{t(messages.Computer_ID())}:</strong> {computer?.id}
          </p>
        </div>

        {computer?.metadata && (
          <div style={{ marginBottom: "20px" }}>
            <h4>{t(messages.MetaData())}</h4>
            <pre
              style={{
                background: "#f8f9fa",
                padding: "12px",
                borderRadius: "6px",
                fontSize: "12px",
                overflow: "auto",
                maxHeight: "200px",
              }}
            >
              {JSON.stringify(computer?.metadata, null, 2)}
            </pre>
          </div>
        )}
      </ModalContent>
    </Modal>
  );
};
